import React, { FormEvent, KeyboardEvent } from 'react';
import { cx } from '../../styles';

interface SearchBoxProps {
  query: string;
  setQuery: (query: string) => void;
  onSearch: (query: string) => void;
  placeholder?: string;
  buttonText?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ 
  query, 
  setQuery, 
  onSearch,
  placeholder = "Ask about zkML research...",
  buttonText = "Search" 
}) => {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSearch(query);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSearch(query);
    }
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className={cx(
        "flex items-center w-full p-2 rounded-full",
        "bg-component border border-divider",
        "focus-within:border-accent focus-within:shadow-md"
      )}
    >
      <input
        type="text"
        className={cx(
          "flex-1 px-4 py-2 bg-transparent outline-none",
          "text-primary placeholder-tertiary"
        )}
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button
        type="submit"
        className={cx(
          "px-6 py-2 rounded-full font-medium",
          "bg-accent-main text-primary-inverse",
          "hover:bg-opacity-90 transition-colors",
          query.trim() ? "" : "opacity-75"
        )}
      >
        {buttonText}
      </button>
    </form>
  );
};

export default SearchBox;
